<template>
    <div v-loading="loading">
        <DepartmentEditor
            :companycode="companycode"
            :list="dataList"
            v-if="null != dataList"
        />
    </div>
</template>

<script setup>

import DepartmentEditor from "@/components/shopopee/department/departmentEditor.vue";
import {inject, ref, toRef, onBeforeMount, onBeforeUnmount} from "vue";
import cardApi from "@/request/api";
import userApi from "@/request/userApi";
import myUtil from "@/util/util";
import {useUserinfo} from "@/stores/userinfo";
import {useAdmininfo} from "@/stores/adminInfo";

const props = defineProps(["companycode"])

const loading = ref(false)
const i18n = inject("i18n")

const userInfoRef = toRef(useUserinfo())
const adminInfoRef = toRef(useAdmininfo())

const dataList = ref(null)
const userObj = ref({})

function getDataList(){
    loading.value = true

    const request = cardApi.queryDepartMemberwork
    const params = request.getParams()

    params.companycode = props.companycode
    params.id = userObj.value.id
    params.login = userObj.value.login
    params.department = null

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            const obj = res.detail

            if (null != obj) {
                if (null != obj.additionalrecord11) {
                    if (null != obj.additionalrecord11.addremark1) {
                        obj.additionalrecord11 = JSON.parse(obj.additionalrecord11.addremark1)
                    }
                }

                let list = []

                if (obj.list.length > 0) {
                    list = obj.list
                    dataList.value = list

                }
            }
        }
    })

}

function queryMemberInfo(){
    loading.value = true

    const request = userApi.queryBusinessBase
    const params = request.getParams()

    params.companycode = props.companycode

    request.send(params, (res) => {
        if (res.code == 200){
            if (null != res.detail){
                userObj.value = res.detail

                myUtil.saveAdminMemberInfo(userInfoRef.value, adminInfoRef.value, userObj.value)

                getDataList()
            }else{
                myUtil.alertError(i18n.tkey("lang_company_not_exist"))
            }
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

onBeforeMount(() => {
    if (null != props.companycode){
        queryMemberInfo()
    }
})

onBeforeUnmount(() => {
    myUtil.loadAdminMemberInfo(userInfoRef.value, adminInfoRef.value)
})

</script>

<style scoped>

</style>